import React from 'react';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { PayoutBank } from 'legacy/events/types';

import getBankLabel from '../../helpers/getBankLabel';

type Props = {
  destination: PayoutBank;
  disabled: boolean;
  isLoading: boolean;
  onShowForm: () => void;
};

const SelectedDestination: React.FC<Props> = ({
  destination,
  disabled,
  isLoading,
  onShowForm
}) => (
  <div className="flex flex-col items-baseline gap-1">
    <p className="text-sm md:text-base text-primary-400">
      {getBankLabel(destination)}
    </p>
    {!disabled && (
      <Button type={ButtonType.Text} onClick={onShowForm} loading={isLoading}>
        Change
      </Button>
    )}
  </div>
);

export default SelectedDestination;
